import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 405  -  资源预加载(仅web用)
 */

export default class EventResourceLoad extends EventBase {



  /**
   * 资源预加载构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }


  // #region 事件内关键属性参数
  /**
   * 文件列表用|分隔
   */
  get FileList() {
    return this.Parameter?.[0] || ''
  }
  set FileList(value:string) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.ResourceLoad
  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
